import { boot } from 'quasar/wrappers'
import type { PluginOptions } from 'vue-gtag'
import VueGtag from 'vue-gtag'

export default boot(async ({ Vue, router }) => {
  Vue.use(VueGtag, {
    config: { id: 'G-TQ5W2BCVT4' },
    appName: 'as',
    pageTrackerScreenviewEnabled: true,
  } as PluginOptions, router)
})
